import { getPrimaryTabsStyles } from './variantStyles/primaryTabs';
export const getTabStyles = (FOUNDATIONS, FONT) => {
    return {
        ...getPrimaryTabsStyles(FOUNDATIONS, FONT),
    };
};
//# sourceMappingURL=styles.js.map